// General
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { Modal } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

// Redux
import { connect } from 'react-redux';
import { closeLoginModal } from '../../actions/modalActions';

// Components
import LoginForm from '../LoginForm';

// Image
import bgImage from '/public/siteImages/carLoginBg.png';
import cs from '../../components/commonStyle.css';
import s from './LoginModal.css';

const LoginModal = ({ loginModal, closeLoginModal, siteName }) => {
  const [loginModalStatus, setLoginModalStatus] = useState(false);

  useEffect(() => {
    if (loginModal === true) {
      setLoginModalStatus(true);
    }
  }, []);

  useEffect(() => {
    setLoginModalStatus(loginModal);
  }, [loginModal]);

  return (
    <Modal show={loginModalStatus} animation={false} onHide={closeLoginModal} dialogClassName='commonModalContainer loginFormModal'>
      <div className={s.carImage} style={{ backgroundImage: `url(${bgImage})` }} />
      <div>
        <Modal.Header closeButton />
        <Modal.Body bsClass={cs.spaceTop5}>
          <LoginForm />
        </Modal.Body>
      </div>
    </Modal>
  );
};

LoginModal.propTypes = {
  closeLoginModal: PropTypes.func,
  loginModal: PropTypes.bool,
  siteName: PropTypes.string.isRequired,
};

const mapState = state => ({
  loginModal: state.modalStatus.isLoginModalOpen,
});

const mapDispatch = {
  closeLoginModal,
};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(LoginModal)));
